import { defineMessages } from 'react-intl';

export default defineMessages({
    searchForTopic: {
        id: 'faq.directive.Search for a topic',
        defaultMessage: 'Search for a topic',
    },
    generalBilling: {
        id: 'faq.sections.General Billing',
        defaultMessage: 'General Billing',
    },
    claim: {
        id: 'faq.sections.Claim',
        defaultMessage: 'Claim',
    },
    customizeFAQContent: {
        id: 'faq.sections.How to customize the FAQ content',
        defaultMessage: 'How to customize the FAQ content',
    },
    frequentlyAskedQuestions: {
        id: 'faq.directive.Frequently Asked Questions',
        defaultMessage: 'Frequently Asked Questions',
    },
    differentWaysToPay: {
        id: 'faq.topics.payment_methods.question',
        defaultMessage: 'What are the different ways to pay for my insurance policy?',
    },
    creditCardPayment: {
        id: 'faq.topics.payment_methods.link.To make a one time credit card payment, please click here.',
        defaultMessage: 'To make a one time credit card payment, please click here.',
    },
    correctBillingMistake: {
        id: 'faq.topics.billing_mistake.question',
        defaultMessage: 'How can I correct a billing mistake made in the last three months?',
    },
    reportBillingMistake: {
        id: 'faq.topics.billing_mistake.link.To report a billing mistake on your last statement, please click here.',
        defaultMessage: 'To report a billing mistake on your last statement, please click here.',
    },
    claimProcess: {
        id: 'faq.topics.when_to_claim.question',
        defaultMessage: 'When is it best to begin the claim process after something happened to my house?',
    },
    renewlaCostInFuture: {
        id: 'faq.topics.claim_rate_increase.question',
        defaultMessage: 'In the event of a claim against the insurance policy, will my insurance costs increase at renewal or at any time in the future?',
    },
    deductible: {
        id: 'faq.topics.deductible_payment.question',
        defaultMessage: 'Under what circumstances would I have to pay a deductible when making a claim?',
    },
    FaqTopic: {
        id: 'faq.topics.show_video.question',
        defaultMessage: 'How to make a youtube video appear in the answer for a FAQ topic?',
    },
    clickableLink: {
        id: 'faq.topics.show_link.question',
        defaultMessage: 'How can I show a clickable link appear in the answer for a FAQ topic?',
    },
    customText: {
        id: 'faq.topics.show_link_text.question',
        defaultMessage: 'How can I show custom text that can be clicked to access a link in the answer for a FAQ topic?',
    },
    clickedText: {
        id: 'faq.topics.show_link_text.This text can be clicked.',
        defaultMessage: 'This text can be clicked.',
    },
    formattingQuestion: {
        id: 'faq.topics.formatting.question',
        defaultMessage: 'How can I customize the format of the question and answer elements for a given topic?',
    },
    bankTransfer: {
        id: 'faq.topics.payment_methods.answer.long',
        defaultMessage: 'Payments can be made using a major credit/debit card or a bank transfer.',
    },
    billngMistake: {
        id: 'faq.topics.billing_mistake.answer.long',
        defaultMessage: 'Billing mistakes should be brought to our attention as soon as they are found to ensure that they are promptly corrected. Please make sure to gather as much information about the mistake such as the date and amounts. You may then contact us through email, chat or phone.',
    },
    eventClaim: {
        id: 'faq.topics.when_to_claim.answer.long',
        defaultMessage: 'In order for us to best serve you in time of need, please notify us of any event that may lead to a claim as soon as you can reasonably expect to make a claim against your insurance policy.',
    },
    increasedRates: {
        id: 'faq.topics.claim_rate_increase.answer.long',
        defaultMessage: 'Filing a claim will not necessarily result in increased rates. Several factors are considered when rating a policy renewal.',
    },
    deductibleAmountasedRates: {
        id: 'faq.topics.deductible_payment.answer.long',
        defaultMessage: 'If the policy stipulates a deductible amount, the deductible amount must be covered when making a claim against the policy.',
    },
    navigateToVideo: {
        id: 'faq.topics.show_video.answer.long',
        defaultMessage: 'Using your browser, navigate to the youtube video that you would like to show. Copy the hash part of the url, for example in the following URL https://www.youtube.com/watch?v=XHB609to9dg the video hash is XHB609to9dg. Insert the video hash inside the topic object under a key named videoId.',
    },
    navigateToExternalLink: {
        id: 'faq.topics.show_link.answer.long',
        defaultMessage: 'Using your browser, navigate to the external link that you would like to show. Copy the url from the browser and insert into a new object as the value for the key url.',
    },
    navigateToExternalLinkText: {
        id: 'faq.topics.show_link_text.answer.long',
        defaultMessage: 'Using your browser, navigate to the external link that you would like to show. Copy the url from the browser and insert into a new object as the value for the key url.',
    },
    customFaq: {
        id: 'faq.topics.formatting.answer.long',
        defaultMessage: 'You can use html markup to customize the FAQ such as:<h2>A list example</h2><ul><li><a href="http://example.com">The first item is a link</a></li><li>The second item is <strong>an emphasis</strong></li><li>The third item is a spinner image <img src="throbber.gif" /></li><li>The fourth item is an escape of the tag &lt;div&gt;</li></ul>',
    },
    typeQuestion: {
        id: 'faq.directive.Start typing your question...',
        defaultMessage: 'Start typing your question...',
    },
    sections: {
        id: 'faq.directive.Sections',
        defaultMessage: 'Sections',
    },
    noMatchingError: {
        id: 'faq.directive.No matching results found',
        defaultMessage: 'No matching results found',
    },
    aboutThePortal: {
        id: 'faq.sections.About the Portal',
        defaultMessage: 'About the Portal',
    },
    purposeOfClaimPortal: {
        id: 'faq.topics.about_portal_for_ph.inline_question',
        defaultMessage: 'What is the purpose of the Claim Portal for Policy Holders?',
    },
    purposeOfClaimPortalQuestion: {
        id: 'faq.topics.about_portal_for_ph.question',
        defaultMessage: 'What is the purpose of the Claim Portal for Policy Holders?',
    },
    purposeOfClaimPortalShortAnswer: {
        id: 'faq.topics.about_portal_for_ph.answer.short',
        defaultMessage: 'Claim Portal for Policyholders can be used to file a claim against a policy based on one or more lines of business',
    },
    purposeOfClaimPortalLongAnswer: {
        id: 'faq.topics.about_portal_for_ph.answer.long',
        defaultMessage: 'Claim Portal for Policyholders can be used to file a claim against a policy based on one or more lines of business.',
    },
    purposeOfClaimPortalProducer: {
        id: 'faq.topics.about_portal_for_producers.inline_question',
        defaultMessage: 'What is the purpose of the Claim Portal for Agents?',
    },
    purposeOfClaimPortalQuestionProducer: {
        id: 'faq.topics.about_portal_for_producers.question',
        defaultMessage: 'What is the purpose of the Claim Portal for Agents?',
    },
    purposeOfClaimPortalShortAnswerProducer: {
        id: 'faq.topics.about_portal_for_producers.answer.short',
        defaultMessage: 'The Claim Portal for Agents is intended for agents that can act on behalf of the insured.',
    },
    purposeOfClaimPortalLongAnswerProducer: {
        id: 'faq.topics.about_portal_for_producers.answer.long',
        defaultMessage: 'The Claim Portal for Agents is intended for agents that can act on behalf of the insured and perform actions like filing a new claim or verifying the status of an existing one.',
    },
    aboutThePortalQuestion: {
        id: 'faq.topics.about.the.portal.for.agents.question',
        defaultMessage: 'What is the purpose of the Claim Portal for Agents?',
    },
    contentAvailable: {
        id: 'faq.topics.content.available',
        defaultMessage: 'Content made Available',
    },
    contentAvailableAllContents: {
        id: 'faq.topics.content.available.contents',
        defaultMessage: 'All content made available on the web portal (for example, text, graphics, logos, button icons, images, digital downloads, data compilations, and software) belongs to Sasria SOC Ltd (“Sasria”), unless we expressly state that it does not and is protected by South African Law. In addition, the compilation of all content on the web portal is the exclusive property of Sasria and is protected by South African copyright laws.',
    },
    contentCopyingFromWebPortal: {
        id: 'faq.topics.claim_copying_content_from_webportal.header',
        defaultMessage: 'Copying or transmitting webportal content',
    },
    contentCopyingFromWebPortalMessage: {
        id: 'faq.topics.claim_copying_content_from_webportal.detail.message.long',
        defaultMessage: 'Except if permitted under this or another agreement with Sasria no portion of the web portal may be copied or transmitted via any means available now or in the future.',
    },
    contentProhibited: {
        id: 'faq.topics.content_prohibiting.header',
        defaultMessage: 'Information or content prohibited',
    },
    informationContentProhibited: {
        id: 'faq.topics.content_prohibiting.detail.message.long',
        defaultMessage: 'Any unauthorized use, alteration or dissemination of the information or content on the web portal is prohibited.',
    },
    breachOfTerms: {
        id: 'faq.topics.breach_of_terms.header',
        defaultMessage: 'Breach of terms',
    },
    breachOfTermsWebDetailMessage: {
        id: 'faq.topics.breach_of_terms.detail.message.long',
        defaultMessage: 'You agree that if you breach the terms of this Copyright clause, Sasria will have the right to claim damages against you, which will include the right to claim special, incidental, consequential or indirect damages. Sasria will also be allowed to claim for loss of profits and loss of business and will also be allowed to recover all legal costs on a scale as between attorney and own client.',
    },
    UseOfTrademarks: {
        id: 'faq.topics.use_of_trademarks.header',
        defaultMessage: 'Use of Trademarks',
    },
    UseOfTrademarksDetailMessage: {
        id: 'faq.topics.use_of_trademarks.detail.message.long',
        defaultMessage: 'Nothing on the web portal should be regarded as granting any license or right to use any trademark without Sasria’s prior written permission and/or that of any third party.',
    },
    breachOfPortal: {
        id: 'faq.topics.breach_of_portal.header',
        defaultMessage: 'Breach of Portal',
    },
    breachOfPortalDetailMessage: {
        id: 'faq.topics.breach_of_portal.detail.message.long',
        defaultMessage: 'Sasria tries to ensure that the most sophisticated technology protects the information on the web portal. However, Sasria cannot be held responsible for any consequences that may result from the unlawful breach of copyright or unlawful dissemination of information by third parties copying information off the web portal. If you suspect a breach or where a breach may have taken place and this comes to your knowledge, please contact us as soon as possible so that we can address the problem.',
    },
    contentDisclaimer: {
        id: 'faq.topicsportal_disclaimer.header',
        defaultMessage: 'Disclaimer',
    },
    contentDisclaimerMessage: {
        id: 'faq.topics.portal_disclaimer.detail.message.long',
        defaultMessage: 'No information included on the web portal should be regarded as either advice or an intermediary service in terms of the Financial Advisory and Intermediary Services Act of 2002.<br /><br />'+
        'While Sasria will take all reasonable measures to ensure an efficient, uninterrupted and error-free service to all its online users, neither Sasria nor any of its employees, representatives or assigns will be liable to any online user for any loss or damage of whatsoever nature caused by or attributable to any:<br /><br />'+
        'fact or circumstance beyond the reasonable control of Sasria, including the breakdown or interruption in the services provided by external service providers and the unavailability or defective performance of any software or any of the services available on or from this web portal;<br /><br />'+
        '1. breach of privacy, security or confidentiality or any infringement of intellectual property rights by any person or entity;<br />'+
        '2. loss, damage, destruction, theft, contamination or corruption of any data, information or content accessible from or available on this web portal;<br />'+
        '3. failure by a user to maintain the confidentiality of their personal username and password, or the disclosure of personal usernames and/or passwords to any person or entity;<br />'+
        '4. cyber-crimes, infection by viruses, Trojan horses, or any other computer programming routines or software that are intended to damage, detrimentally interfere with, surreptitiously intercept or expropriate any software programme, system, data or personal information;<br />'+
        '5. failure to adhere to the provisions of any terms and conditions governing the use and access to the services and facilities offered on this web portal;<br />'+
        '6. any lawful act or omission by Sasria, its representatives and service providers in respect of or relating to the maintenance and support of this web portal and any supporting software or otherwise in the interests of protecting Sasria’s proprietary rights or the privacy and confidentiality of online users / policyholders and their personal information;<br />'+
        '7. and consequential or indirect loss or damage whether foreseeable or otherwise.'
    },
    companyPrivacyPolicy: {
        id: 'faq.topics.privacy_policy.header',
        defaultMessage: 'SASRIA PRIVACY POLICY',
    },
    contentPrivacyPolicy: {
        id: 'faq.topics.privacy_policy.detail.message.long',
        defaultMessage: '1.	Introduction <br /><br />'+
        '   Sasria SOC Limited (“Sasria”) will on an ongoing basis receive and process Personal Information and is committed to ensuring that privacy and integrity of Personal Information received through this website. The processing of Personal Information is regulated by the Protection of Personal Information Act, 4 of 2013 (“POPIA”)<br /><br />'+
        '   POPIA defines Personal Information as information relating to an identifiable, living, natural person and where applicable, an identifiable, existing person. This includes but not limited to names, Identity numbers, and nationality.<br /><br />'+
        '   In order to give effect to the provisions of POPIA, Sasria is obliged to provide any person whose Personal Information is processed by it with details relating to the use of and processing of such Personal Information before it is used or processed.<br /><br />'+
        '2.	Accountability <br /><br />'+
        '   Sasria will only use or process Personal Information in accordance with the provisions of POPIA and the terms of this Privacy Policy.<br /><br />'+
        '   In instances where Sasria shares any Personal Information to a Responsible Party  or Operator , then such person will be required to process such Personal Information in accordance with the provisions of POPIA and the terms of this Privacy Policy. In this regard, all relevant data privacy principles relating to the processing of Personation Information received by Sasria or provided by Sasria to another person as a result of the use of this website shall apply unless exceptions are provided for in terms of POPIA.<br /><br />'+
        '3.	Consent to process<br /><br />'+
        '   By accessing and/or using this website, you:<br /><br />'+
        '       •	Acknowledge that you have read and understood this Privacy Policy and agree to be bound by and comply by its provisions; and<br />'+
        '       •	give Sasria consent to process and further process your Personal Information for the required purpose;<br /><br />'+
        '   Where Personal Information is provided to Sasria on behalf of another or is that of a minor, such Personal Information will not be processed unless such a query pr request is accompanied by the necessary permission or consent from the owner of that Personal Information, or the minor’s parent or legal guardian, whichever is applicable. <br /><br />'+
        '4.	Receipt and use of Personal Information <br /><br />'+
        '   Sasria will receive your Personal Information when you submit a query or request through available channels (namely email link and/or “contact us” platform). The use or processing of <br /><br /><br />'+
        '_____________________________<br />'+
        '       1.   Means a public or private body or any other person who determines the purpose of and means for processing Personal Information.<br />'+
        '           2.   Means a person who processes Personal Information for a Responsible Party in terms of a contract or mandate, without coming under the direct authority of that part.<br /><br /><br />'+
        '   Personal Information shall be for business purposes which include but not limited to assisting visitor with complaints or escalation thereof as.<br /><br />'+
        '   To handle any query or request correctly, Sasria may from time to time share the Personal Information with its employees or agents.  Sasria will not share any of your Personal Information with any third parties unless it is legally obliged to do so for legal or regulatory purposes, or as provided for in POPIA. <br /><br />'+
        '   On receipt and in response to a query or a request received via this website, Sasria may transmit its own Personal Information and such Personal Information may only be used by you Or the receiving party for the purposes relating to the request or query and for no other purpose. <br /><br />'+
        '5.	Use of Cookies <br /><br />'+
        '   Sasria uses cookies on its website where they are required for particular features to work.<br /><br />'+
        '   A cookie is generally a tiny data file that resides on your computer or mobile devices and allows Sasria to recognise you as a user when browsing Sasria’s website. We use cookies to record information about your computer/device, your browser, in some case your preferences, and browsing habits. <br /><br />'+
        '   You can remove or block cookies using the settings in your browser, but in some cases may impact certain features of the Online Services to be unavailable to you.<br /><br />'+
        '6.	Security of Personal Information<br /><br />'+
        '   Due to the nature of the internet, it is not possible to guarantee that Personal Information submitted or posted on our website is secure.  Sasria will strive to maintain a safe and comfortable browsing experience with minimum risks to the visitor.  Notwithstanding this, Sasria cannot be held responsible for any loss or unauthorised use or interception of Personal Information transmitted through the website, which is beyond Sasria’s reasonable control. <br /><br />'+
        '   The Sasria website may and/or contain links to other websites outside of Sasria’s control and Sasria is not responsible for the content, privacy or security of websites controlled by third party websites.  Sasria also makes use of social plugin of social networks such as Facebook, LinkedIn, YouTube, and Twitter. Sasria, will not be held liable for any processing or use of Personal Information transmitted through the social plugins. <br /><br />'+
        '7.	Policy Changes <br /><br />'+
        '   Sasria reserves the right to update or amend this Policy from time to time. You are therefore encouraged to review the Policy when visiting the website for any changes. <br /><br />'+
        '   The amended version of this Policy shall supersede and replace all previous versions thereof.'

    }
});
